import { Card, Group, Stack, Text } from '@mantine/core';

import { ButtonMantine } from '../../../../Buttons';

type NoDataMessageCardProps = {
  leftSection?: React.ReactNode;
  title: string;
  message: string;
  cta?: {
    label: string;
    onClick: () => void;
  };
};

const NoDataMessageCard = ({ leftSection, title, message, cta }: NoDataMessageCardProps) => {
  return (
    <Card bg="gray.0" bd="1px solid gray.1" shadow="0">
      <Stack>
        <Group wrap="nowrap" align="flex-start">
          {leftSection}
          <Stack gap={4} c="gray">
            <Text fz="xs" fw={600}>
              {title}
            </Text>
            <Text fz="xxxs">{message}</Text>
          </Stack>
        </Group>
        {cta && (
          <ButtonMantine size="sm" onClick={cta.onClick}>
            {cta.label}
          </ButtonMantine>
        )}
      </Stack>
    </Card>
  );
};

export { NoDataMessageCard };
